import { z as zod } from 'zod';
import { HeroIntroSchema } from "@/app/features/shared/intros/hero/types/HeroIntro.schema";
import { MediaRefSchema } from "@/app/features/shared/__to_be_integrated/types/forms/MediaRefSchema";
import { DetailSchema } from "@/app/features/shared/types/schema";

export const SiteResearchSchema = zod.object({
    intro: HeroIntroSchema,
});

export const ResearchOverviewItemSchema = zod.object({
    id: zod.string(),
    title: zod.string().min(1, 'Titel darf nicht leer sein'),
    subtitle: zod.string().nullish(),
    excerpt: zod.string().nullish(),
    image: MediaRefSchema.nullish(),
});

export const ResearchDetailSchema = zod.object({
    id: zod.string(),
    title: zod.string().min(1, 'Titel darf nicht leer sein'),
    subtitle: zod.string().nullish(),
    excerpt: zod.string().nullish(),
    publications: zod.string().nullish(),
    image: MediaRefSchema,
    details: zod.array(DetailSchema),
});
